<div
  class="dynamic-data-table-scroll"
  [class.dynamic-data-table-scroll--dark]="isDarkMode"
>
  <table class="dynamic-data-table ch-api-data-table">
    <thead>
      <tr>
        <th
          *ngFor="let header of headers; let columnIndex = index; trackBy: trackHeader"
          [class.dynamic-data-table__th--numeric]="isNumericColumn(columnIndex)"
          [title]="header"
        >
          {{ header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="no-hover onboarding-detail-row"
        *ngFor="let row of rows; let rowIndex = index; trackBy: trackRow"
      >
        <td
          *ngFor="let cell of row; let columnIndex = index"
          [class.dynamic-data-table__td--numeric]="isNumericColumn(columnIndex)"
          [title]="cell"
        >
          <input
            *ngIf="editable && isEditing"
            class="form-control form-control-sm onboarding-mini-table__input"
            type="text"
            [(ngModel)]="rows[rowIndex][columnIndex]"
          />
          <span
            *ngIf="!editable || !isEditing"
            class="onboarding-mini-table__value"
          >{{ cell }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
